/**
 * Classes Tailwind des badges de la console Diffusions (statut / type / réseau).
 */

import type { DiffusionStatus } from '@jeraisonne/db/diffusions';

export function statusBadgeClasses(status: DiffusionStatus): string {
  switch (status) {
    case 'scheduled':
      return 'bg-primary-100 text-primary-700';
    case 'publishing':
      return 'bg-amber-100 text-amber-700';
    case 'published':
      return 'bg-emerald-100 text-emerald-700';
    case 'failed':
      return 'bg-red-100 text-red-700';
    case 'draft':
    default:
      return 'bg-ink-100 text-ink-600';
  }
}

/** Couleur de pastille par réseau (repère visuel rapide). */
export function platformDotClasses(platform: string): string {
  switch (platform) {
    case 'youtube':
      return 'bg-red-500';
    case 'tiktok':
      return 'bg-ink-900';
    case 'instagram_reels':
    case 'instagram':
      return 'bg-pink-500';
    case 'facebook_reels':
    case 'facebook':
      return 'bg-blue-600';
    case 'linkedin':
      return 'bg-sky-700';
    default:
      return 'bg-ink-400';
  }
}
